export default [
  {
    path: '/balance-report-vip',
    name: 'balance-report-vip',
    component: () => import('@/views/balanceReportVip/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.balanceReportVip',
      resource: 'balance-report-vip',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listBalanceReportVip',
          active: true,
        },
      ],
    },
  },
]
